import { formValue, whenNot } from 'platform/shared/health-apps';
import { roleIsNotSponsor } from './certifier';

export const sponsorIsDeceased = formData =>
  roleIsNotSponsor(formData) &&
  Boolean(formValue('sponsorIsDeceased')(formData));

export const sponsorIsLiving = whenNot(sponsorIsDeceased);

export const hasSponsorAddress = formData =>
  Boolean(formValue('sponsorAddress.street')(formData));
